<template>
 <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item label="地图初始地区" prop="region">
        <a-select v-model="form.mapName" allowClear>
          <a-select-option
            v-for="(value, key) in items"
            :key="key"
            :value="key"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="摄像头最大拍摄长度（m）" prop="cameraLength">
        <a-input
          v-model="form.cameraLength"
          placeholder="摄像头最大拍摄长度"
          type="number"
        />
      </a-form-model-item>
      <tk-flex right>
        <a-button type="primary" @click="submit">
          保存
        </a-button>
      </tk-flex>
    </a-form-model>
</template>
<script>
import { notEmpty } from '../utils/validator.js'

import { EXISTING_SECOND_LAYER_REGION } from './mapDrilling/constant.js'
export default {
  data () {
    return {
      form: {
        cameraLength: 0,
        mapName: ''
      },
      rules: {
        cameraLength: [
          { required: true, message: '不可为空', trigger: ['change', 'blur'], validator: this.validatorLength }
        ]
      },
      items: this.generateRegionItems()
    }
  },
  name: 'GlobalSetting',
  mounted () {
    this.getSettingData()
  },
  methods: {
    async getSettingData () {
      const { data } = await this.$tkParse.get('/settings')
      this.form.cameraLength = data.cameraLength
      this.form.mapName = data.mapName
    },
    generateRegionItems () {
      const ret = {}
      EXISTING_SECOND_LAYER_REGION.forEach(item => {
        ret[item.adcode.toString()] = item.name
      })
      return ret
    },
    validatorLength (rule, value, callback) {
      const error = notEmpty()(value)
      if (error) {
        callback(new Error(error))
      } else {
        callback()
      }
    },
    async submitCB () {
      await this.$tkParse.post('/settings', {
        cameraLength: this.form.cameraLength || 0,
        mapName: this.form.mapName || ''
      })
      this.$notification['success']({
        message: '操作成功',
        description: '数据保存成功'
      })
    },
    submit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitCB()
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style></style>
